import React from 'react';
import styles from './TierBadge.module.css';

export type Tier = 'A' | 'B' | 'C';

interface TierBadgeProps {
  tier: Tier;
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier }) => {
  return <span className={`${styles.badge} ${styles[`tier_${tier}`]}`}>Tier {tier}</span>;
};
